import * as React from "react"
import { Button } from "@/components/ui/button"
import { LoaderPinwheel } from "lucide-react"
import { cn } from "@/lib/utils"

interface ProgressButtonProps extends React.ComponentProps<typeof Button> {
  disabled?: boolean
  isLoading?: boolean
}

export const ProgressButton = React.forwardRef<HTMLButtonElement, ProgressButtonProps>(
  ({ isLoading = false, children, className, ...props }, ref) => {
    const isDisabled = isLoading || props.disabled

    return (
      <Button
        ref={ref}
        className={cn("gap-2", className)}
        disabled={props.disabled}
        {...props}
      >
        <div className={cn("contents", isDisabled && "opacity-50 pointer-events-none")}>
          {children}
        </div>
        {isLoading && <LoaderPinwheel className="h-4 w-4 animate-spin" />}
      </Button>
    )
  }
)

ProgressButton.displayName = "ProgressButton"
